import React from 'react';

export const searchGridStyle: React.CSSProperties = { paddingLeft: 0 };

export const dropdownGridStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '0.5rem',
};
